import React, {Component} from "react";
import PropTypes from "prop-types";
import {Link} from "react-router-dom";
import {withRouter} from "react-router";
import {Navbar, NavbarNav, NavbarToggler, Collapse, NavItem, NavLink, Dropdown, DropdownMenu, DropdownItem, DropdownToggle} from 'mdbreact';
import UserProfile from "./UserProfile";
import Search from "./Search";
import "./header.css";
import {connect} from "react-redux";

class Header extends Component {
    constructor(props) {
        super(props);
        this.state = {
            collapse: false,
            isWideEnough: false,
            dropdownnOpen: false,
            loading: false,
            menuOpen: false,
        };
        this.onClick = this.onClick.bind(this);
        this.toggle = this.toggle.bind(this);
    }

    onClick() {
        this.setState({
            collapse: !this.state.collapse,
        });
    }

    toggle() {
        this.setState({
            dropdownOpen: !this.state.dropdownOpen
        });
    }

    render() {
        const {isAuthenticated} = this.props;

        return (
            <Navbar color="m-grid__item m-header rtl " expand="lg" fixed="top" scrolling className={this.props.location.pathname !== '/'?'top-nav-collapse':''}>
                {!this.state.isWideEnough && <NavbarToggler onClick={this.onClick} className={!this.state.collapse ? 'collapsed' : ''}><span/></NavbarToggler>}

                <div className="page-logo">
                    <Link to="/">
                        <img src="./../../assets/images/logo.svg" height="150" alt="سامانه تخفیف هوشمند "/>
                    </Link>
                </div>

                {/*<Collapse isOpen={this.state.collapse} navbar className="d-flex justify-content-between">*/}
                <Collapse isOpen={this.state.collapse} navbar className="d-flex1 justify-content-between1">
                    <div className="m-header-menu m-aside-header-menu-mobile">
                        <NavbarNav className="m-menu__nav">
                            <NavItem active>
                                <NavLink className="nav-link m-menu__item" to="/" exact>صفحه اصلی</NavLink>
                            </NavItem>
                            <NavItem>
                                <NavLink className="nav-link m-menu__item" to="/products">محصولات</NavLink>
                            </NavItem>
                            <NavItem>
                                <NavLink className="nav-link m-menu__item" to="/how-it-works">راهنمای استفاده</NavLink>
                            </NavItem>
                            {/*<NavItem>*/}
                                {/*<NavLink className="nav-link m-menu__item" to="/community">باشگاه مشتریان</NavLink>*/}
                            {/*</NavItem>*/}
                            <NavItem>
                                <NavLink className="nav-link m-menu__item" to="/contact-us">تماس با ما</NavLink>
                            </NavItem>



                           {/* <NavItem className="d-lg-none">
                                <NavLink  title="سبد خربد" to="/shopping-card">سبد خرید
                                    <Badge color="danger">2</Badge>
                                </NavLink>
                            </NavItem>*/}
                            <NavItem className="d-lg-none">
                                {/*{isAuthenticated ? <UserProfile /> : <NavLink to="/login" title="ورود کاربر"><i className=" flaticon-user "/></NavLink>}*/}
                                {isAuthenticated ? <UserProfile  /> :
                                    <div style={{padding:0,margin:0}}>
                                            <NavLink className="nav-link1 m-menu__item1 login-menu" to="/login">ورود</NavLink>
                                            <NavLink className="nav-link m-menu__item" to="/register">ثبت نام</NavLink>
                                    </div>
                                }
                            </NavItem>
                            <NavItem className="d-lg-none lang-wapper">
                                <Dropdown isopen = { this.state.dropdownOpen } toggle = { this.toggle }>
                                    <DropdownToggle  caret color="link" style={{padding: 4}}>
                                        <img src="./../../assets/images/flags/ir.png" alt="fa" /> فارسی
                                    </DropdownToggle>
                                    <DropdownMenu className="lang-dropdown">
                                        <DropdownItem><img src="./../../assets/images/flags/ir.png" alt="fa" /> فارسی </DropdownItem>
                                        <DropdownItem><img src="./../../assets/images/flags/gb.png" alt="en" /> English </DropdownItem>
                                        <DropdownItem ><img src="./../../assets/images/flags/ae.png" alt="ar" /> عربی </DropdownItem>
                                    </DropdownMenu>
                                </Dropdown>
                            </NavItem>


                        </NavbarNav>
                    </div>
                </Collapse>

                <div className="d-none d-lg-block mt-3">
                    <div className="d-flex flex-row top-link ">
                        <div className="p-2"><Search/></div>
                        <div className="separator">|</div>
                        {/*<div className="p-2">
                           <NavLink  title="سبد خربد" to="/shopping-card">
                                <i className="flaticon-business "></i>
                            </NavLink>
                        </div>*/}
                        <div className="p-1">
                            {isAuthenticated ? <UserProfile  /> :
                                <div style={{padding:0,margin:0}}>
                                    <Link to="/login" title="ورود کاربر" className="btn btn-deep-orange top-btn">ورود</Link>
                                    <Link to="/register" title="عضویت در سامانه" className="btn btn-primary top-btn">ثبت نام</Link>
                                </div>
                            }
                        </div>
                        <div className="separator ">|</div>
                        <div className="p-2 lang-wapper">
                            <Dropdown isopen = { this.state.dropdownOpen } toggle = { this.toggle }>
                                <DropdownToggle  caret color="link" style={{padding: 4}}>
                                    <img src="./../../assets/images/flags/ir.png" alt="fa" /> فارسی
                                </DropdownToggle>
                                <DropdownMenu className="lang-dropdown">
                                    <DropdownItem><img src="./../../assets/images/flags/ir.png" alt="fa" /> فارسی </DropdownItem>
                                    <DropdownItem><img src="./../../assets/images/flags/gb.png" alt="en" /> English </DropdownItem>
                                    <DropdownItem ><img src="./../../assets/images/flags/ae.png" alt="ar" /> عربی </DropdownItem>
                                </DropdownMenu>
                            </Dropdown>
                        </div>
                    </div>
                </div>
            </Navbar>
        );
    }
}

Header.propTypes = {
    // user: PropTypes.string,
    // logoutUser: PropTypes.func.isRequired,
    isAuthenticated :PropTypes.bool
};
const mapStateToProps = (state) => {
    return {
        categories: state.categories,
    }
};


export default connect(mapStateToProps,null)(withRouter(Header));
// export default withRouter(Header);



// WEBPACK FOOTER //
// ./src/components/header/Header.js